<template>
  <!-- Display zoom instructions -->
  <p ref="zoomInstructions" class="eventmap__zoom-instructions">
    {{ __('eventmap.use_command_scroll_to_zoom') }}
  </p>
</template>

<script setup>
// Define ref for zoom instructions
import { ref, defineExpose } from 'vue';

const zoomInstructions = ref(null);

// Expose zoom instructions ref to parent components
defineExpose({
  zoomInstructions,
});
</script>

<style>
.eventmap__zoom-instructions {
  position: absolute;
  display: none;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: var(--system-black);
  color: var(--system-white);
  font-size: var(--font-medium-large);
  pointer-events: none;
  opacity: 0.8;
}
</style>
